<template>
  <div class="container">
    <div class="register-page">
      <div class="header">
        <span>{{ title }}</span>
      </div>
      <div class="content">
        <RegisterPanel />
      </div>
    </div>
  </div>
</template>

<script>
import RegisterPanel from "@/components/account/RegisterPanel.vue";

export default {
  name: "RegisterPage",
  components: {
    RegisterPanel,
  },
  data() {
    return {
      title: "Register",
    };
  },
  mounted() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const refParam = urlParams.get("ref");

    if (refParam === "sale") {
      this.title = "Sign Up";
    } else {
      this.title = "Register";
    }
  },
};
</script>

<style lang="scss" scoped>
.register-page {
  text-align: center;
  width: 100%;
  max-width: 500px;
  margin: 30px auto 0;
  border: 1px solid rgba($color-grey-dark, 0.2);

  .header {
    padding: 0 20px;
    font-size: 16px;
    font-family: $heading-font-family;
    text-transform: uppercase;
    background-color: $color-grey-light;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include respond-above(md) {
      flex: 0 0 auto;
    }

    & > span {
      padding: 16px 0;
    }
  }

  .content {
    padding: 16px;
    text-align: left;
  }
}
</style>
